export const HR_REMINDERS = '/hr/Reminders'
export const HR_REMINDERS_COUNT = `${HR_REMINDERS}/count`
export const HR_REMINDERS_ME = `${HR_REMINDERS}/me`

export function reminderById(id: number) {
  return `${HR_REMINDERS}/${id}`
}

export function reminderMeById(id: number) {
  return `${HR_REMINDERS_ME}/${id}`
}
